import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import './ItemList.scss';

export default function ItemList({ children, className }) {
  return <div className={cn('cp-item-list', className)}>{children}</div>;
}

ItemList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
